import { COLORS } from '@btime/constants'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../packages/kiti/components/presentation/Text'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Link from '../../packages/kiti/components/actions/Link'

const IconCount = ({ value, icon, onClick, color }) => {
  const hasValue = value > 0
  const finalColor = color || (hasValue ? COLORS.purple : COLORS.light3)

  return (
    <Link onClick={() => hasValue && onClick && onClick()}>
      <Grid gap={0.15} justify="flex-start" align="center">
        <Icon name={icon} size={1} color={finalColor} />
        <SmallText bold color={finalColor}>
          {value}
        </SmallText>
      </Grid>
    </Link>
  )
}

export default IconCount
